import React, { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

import ActionCable from 'components/ActionCable/Cable';
import IconMainContainer from 'components/IconMainContainer';
import { postRequest } from 'utils/api';
import { getUuid } from 'utils/localStorage';
import toast from 'utils/toast';
import useCheckoutSuccess from 'hooks/useCheckoutSuccess';

const GooglePayForm = () => {
  const cart = useSelector(state => state.cart);
  const isLoggedIn = useSelector(state => state.auth.loggedIn);
  const handleCheckoutSuccess = useCheckoutSuccess('google_pay');

  const handleSubmit = useCallback(
    response => {
      if (response.token) {
        const uuid = getUuid();
        const endpoint = isLoggedIn
          ? `carts/${cart.id}/checkout?async=true`
          : `carts/${uuid}/guest_checkout`;

        const { cardDetails, billingInfo } = response.wallet;

        postRequest({
          endpoint,
          data: {
            payment_method: 'google_pay',
            token: response.token,
            card: {
              last4: cardDetails,
              billing_details: {
                name: `${billingInfo?.firstName} ${billingInfo?.lastName}`,
                zip: billingInfo?.postalCode,
                country: billingInfo?.country,
              },
            },
          },
          successMessage: '',
          errorMessage:
            'There was an error during the checkout. Please try again or contact support.',
        })
          .then(() => {
            if (isLoggedIn) {
              // Do nothing, we're waiting for the WebSocket update
            } else {
              handleCheckoutSuccess({ cart_id: cart.id });
            }
          })
          .catch(error => console.log('error', error));
      } else {
        toast('error', 'There was an error validating your payment method.', {
          icon: <IconMainContainer src="/icons/notifications/times.svg" alt="Times" errorStyle />,
        });
      }
    },
    [cart.id, handleCheckoutSuccess, isLoggedIn]
  );

  useEffect(() => {
    if (!window.CollectJS) return;

    window.CollectJS.configure({
      variant: 'inline',
      styleSniffer: true,
      callback: response => {
        handleSubmit(response);
      },
      country: 'US',
      currency: 'USD',
      price: cart.total_checkout_price,
      fields: {
        googlePay: {
          selector: '#google-pay-button',
          shippingAddressRequired: false,
          billingAddressRequired: true,
          emailRequired: false,
          buttonType: 'buy',
          buttonColor: 'black',
          buttonLocale: 'en',
        },
      },
    });
  }, [cart.total_checkout_price, handleSubmit]);

  return (
    <>
      <ActionCable
        channel="CheckoutChannel"
        onReceived={({ type, payload }) => {
          if (type === 'success') {
            handleCheckoutSuccess(payload);
          } else {
            console.log('Checkout error', payload);
            toast(
              'error',
              payload?.errors?.[0] ||
                'There was an error during the checkout. Please try again or contact support.',
              {
                icon: (
                  <IconMainContainer src="/icons/notifications/times.svg" alt="Times" errorStyle />
                ),
              }
            );
          }
        }}
      />
      <div id="google-pay-button" style={{ margin: '20px 0', padding: '0 15px' }}></div>
    </>
  );
};

export default GooglePayForm;
